export const dateTime = {
  dateFormat: 'YYYY-MM-DD',
  timeFormat: 'HH:mm:ss',
  fullFormat: 'YYYY-MM-DD HH:mm:ss',
};
